import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    TextField
} from "@mui/material";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import FamilyMemberForm from "pages/EmployeeWorkspace/components/Tabs/components/FamilyBackgroundTab/components/FamilyMemberForm";
import { formatDateForInput } from "utils/helpers/dateHelper";

import familyMemberSchema from "pages/EmployeeWorkspace/validation/familyMemberSchema";

const defaultValues = {
    relation: "",
    firstName: "",
    lastName: ""
};

export default function FamilyMemberDialog({ open, item, onSave, onCancel }) {
    const {
        register,
        handleSubmit,
        reset,
        control,
        formState: { errors }
    } = useForm({
        defaultValues,
        resolver: yupResolver(familyMemberSchema)
    });

    console.log({ item });

    useEffect(() => {
        if (open) {
            reset({
                ...defaultValues,
                ...item,
                dateOfBirth: formatDateForInput(item?.dateOfBirth)
            });
        }
    }, [open, item, reset]);

    const onSubmit = (data) => {
        onSave(data);
    };

    return (
        <Dialog open={open} onClose={onCancel} maxWidth="md" fullWidth>
            <DialogTitle>
                {item ? "Edit Family Member" : "Add Family Member"}
            </DialogTitle>

            <DialogContent dividers>
                <FamilyMemberForm
                    register={register}
                    errors={errors}
                    control={control}
                />
            </DialogContent>

            <DialogActions>
                <Button onClick={onCancel}>Cancel</Button>

                <Button variant="contained" onClick={handleSubmit(onSubmit)}>
                    Save
                </Button>
            </DialogActions>
        </Dialog>
    );
}
